// Recovered compiled webpack factory 88785. Edit this function expression; run npm run build.
(e, t, r) => {
  "use strict";
  (Object.defineProperty(t, "__esModule", { value: !0 }),
    !(function (e, t) {
      for (var r in t) Object.defineProperty(e, r, { enumerable: !0, get: t[r] });
    })(t, {
      ErrorBoundary: function () {
        return f;
      },
      ErrorBoundaryHandler: function () {
        return c;
      },
    }));
  let n = r(28140),
    a = r(95155),
    o = n._(r(12115)),
    i = r(51486),
    s = r(5829);
  r(61489);
  let l = r(15860),
    u = (0, r(93913).isBot)(window.navigator.userAgent);
  class c extends o.default.Component {
    static getDerivedStateFromError(e) {
      if ((0, s.isNextRouterError)(e)) throw e;
      return { error: e };
    }
    static getDerivedStateFromProps(e, t) {
      let { error: r } = t;
      return e.pathname !== t.previousPathname && t.error
        ? { error: null, previousPathname: e.pathname }
        : { error: t.error, previousPathname: e.pathname };
    }
    render() {
      return this.state.error && !u
        ? (0, a.jsxs)(a.Fragment, {
            children: [
              (0, a.jsx)(l.HandleISRError, { error: this.state.error }),
              this.props.errorStyles,
              this.props.errorScripts,
              (0, a.jsx)(this.props.errorComponent, { error: this.state.error, reset: this.reset }),
            ],
          })
        : this.props.children;
    }
    constructor(e) {
      (super(e),
        (this.reset = () => {
          this.setState({ error: null });
        }),
        (this.state = { error: null, previousPathname: this.props.pathname }));
    }
  }
  function f(e) {
    let { errorComponent: t, errorStyles: r, errorScripts: n, children: o } = e,
      s = (0, i.useUntrackedPathname)();
    return t
      ? (0, a.jsx)(c, {
          pathname: s,
          errorComponent: t,
          errorStyles: r,
          errorScripts: n,
          children: o,
        })
      : (0, a.jsx)(a.Fragment, { children: o });
  }
  ("function" == typeof t.default || ("object" == typeof t.default && null !== t.default)) &&
    void 0 === t.default.__esModule &&
    (Object.defineProperty(t.default, "__esModule", { value: !0 }),
    Object.assign(t.default, t),
    (e.exports = t.default));
}
